export const parameterTypes = {
    FLOAT: 'הזנת ספרות בלבד',
    STRING: 'הזנת טקסט בלבד',
    BOOLEAN: 'בחירת תשובה כן/לא'
}
